import { HttpError, LoyaltyProgram, LoyaltyProgramCategory } from '@rd/types';
import { toObject } from '@rd/utils/array.utils';
import {
  LoyaltyProgramActions,
  LoyaltyProgramActionTypes,
} from '../actions/loyalty-program.actions';

export interface LoyaltyProgramState {
  loyaltyPrograms: {
    [key: string]: Partial<LoyaltyProgram>;
  };
  filter: {
    category: LoyaltyProgramCategory | 'all';
    keyword: string;
  };
  index: {
    error: HttpError | null;
    loading: boolean;
  };
  show: {
    error: HttpError | null;
    loading: boolean;
  };
}

const initialState: LoyaltyProgramState = {
  loyaltyPrograms: {},
  filter: {
    category: 'all',
    keyword: '',
  },
  index: {
    error: null,
    loading: false,
  },
  show: {
    error: null,
    loading: false,
  },
};

export function loyaltyProgramReducer(
  state: LoyaltyProgramState = initialState,
  action: LoyaltyProgramActions,
): LoyaltyProgramState {
  switch (action.type) {
    case LoyaltyProgramActionTypes.CHANGE_LOYALTY_PROGRAMS_FILTER_CATEGORY:
      return {
        ...state,
        filter: {
          ...state.filter,
          category: action.payload,
        },
      };

    case LoyaltyProgramActionTypes.CHANGE_LOYALTY_PROGRAMS_FILTER_KEYWORD:
      return {
        ...state,
        filter: {
          ...state.filter,
          keyword: action.payload,
        },
      };

    case LoyaltyProgramActionTypes.LOAD_LOYALTY_PROGRAMS:
      return {
        ...state,
        index: {
          ...state.index,
          loading: true,
        },
      };

    case LoyaltyProgramActionTypes.LOAD_LOYALTY_PROGRAMS_SUCCESS:
      return {
        ...state,
        loyaltyPrograms: toObject(action.payload, 'id'),
        index: {
          error: null,
          loading: false,
        },
      };

    case LoyaltyProgramActionTypes.LOAD_LOYALTY_PROGRAMS_FAIL:
      return {
        ...state,
        loyaltyPrograms: {},
        index: {
          error: action.payload,
          loading: false,
        },
      };

    case LoyaltyProgramActionTypes.LOAD_SINGLE_LOYALTY_PROGRAM:
      return {
        ...state,
        show: {
          ...state.show,
          loading: true,
        },
      };

    case LoyaltyProgramActionTypes.LOAD_SINGLE_LOYALTY_PROGRAM_SUCCESS:
      return {
        ...state,
        loyaltyPrograms: {
          ...state.loyaltyPrograms,
          [action.payload.id]: action.payload,
        },
        show: {
          error: null,
          loading: false,
        },
      };

    case LoyaltyProgramActionTypes.LOAD_SINGLE_LOYALTY_PROGRAM_FAIL:
      return {
        ...state,
        show: {
          error: action.payload,
          loading: false,
        },
      };
  }

  return state;
}
